import * as T from '@/core/configs/types'
import { Note } from './note'
import { Container } from './container'
import { getYearsPrependOptions } from '../utils/date'
import { Order } from './order'
import { AddressBook } from './address'
import { appendBefore } from '../utils'
import { queryCustomers } from '@/api/customer'
import { Shipment } from './shipment'

export const PalletUpcoming = 'Upcoming'
export const PalletOnStack = 'OnStack'
export const PalletOffStack = 'OffStack'
export const PalletOnStage = 'OnStage'
export const PalletShipping = 'Shipping'
export const PalletDelivered = 'Delivered'
export const PalletDeleted = 'Deleted'
export const PalletStatus = {
  PalletUpcoming,
  PalletOnStack,
  PalletOffStack,
  PalletOnStage,
  PalletShipping,
  PalletDelivered,
  PalletDeleted
}
export const PalletStatusForCreatingInboundJobs = {
  PalletUpcoming,
  PalletOffStack
}
export const PalletStatusForCreatingOutboundJobs = {
  PalletOnStack
}

export const NotIncludeDeleted = [
  PalletUpcoming,
  PalletOnStack,
  PalletOffStack,
  PalletOnStage,
  PalletShipping,
  PalletDelivered
]

export const NormalPallet = 'Normal'
export const MediumPallet = 'Medium'
export const HighPallet = 'High'
export const PalletPriority = {
  NormalPallet,
  MediumPallet,
  HighPallet
}

export const Pallet = {
  id: {
    type: T.String,
    label: 'Pallet ID',
    key: 'id',
    col: 'pallet_id'
  },
  no: {
    type: T.String,
    label: 'Pallet No',
    key: 'no',
    col: 'pallet_no'
  },
  slotId: {
    type: T.String,
    label: 'Slot ID',
    key: 'slotId',
    col: 'slot_id'
  },
  status: {
    type: T.Enum,
    label: 'Pallet Status',
    key: 'status',
    options: Object.values(PalletStatus),
    col: 'pallet_status'
  },
  priority: {
    type: T.Enum,
    label: 'Pallet Priority',
    key: 'priority',
    options: Object.values(PalletPriority),
    col: 'priority'
  },
  groupName: {
    type: T.String,
    label: 'Group Name',
    key: 'groupName',
    col: 'group_name'
  },
  quantity: {
    type: T.Number,
    label: 'Quantity',
    key: 'quantity',
    col: 'quantity'
  },
  notes: {
    type: T.Array,
    itemType: T.Ref,
    ref: Note,
    label: 'Note',
    key: 'notes'
  },
  goods: {
    type: T.Array,
    itemType: T.String,
    label: 'Goods',
    key: 'goods'
  },
  hold: {
    type: T.String,
    label: 'Hold',
    key: 'hold',
    col: 'hold'
  },
  addressId: {
    type: T.Text,
    label: 'Address ID',
    key: 'addressId',
    col: 'address_id'
  },
  address: {
    type: T.Ref,
    ref: AddressBook,
    label: 'Address',
    key: 'address'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime',
    col: 'created_time'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime',
    col: 'updated_time'
  }
}

export const PalletInfoPicks = [
  { ...Pallet.no, type: T.Text, span: 1 },
  {
    label: 'Slot No',
    key: 'slotNo',
    type: T.Text,
    span: 1
  },
  { ...Pallet.status, type: T.Tag, effect: 'dark', span: 1 },
  { ...Pallet.priority, type: T.Tag, effect: 'plain', span: 1 },
  { ...Pallet.quantity, type: T.Text, span: 1 },
  { ...Pallet.hold, type: T.HoldTag, span: 1, mutable: false },
  { ...Pallet.groupName, type: T.Text, span: 1 },
  { ...Pallet.createdTime, type: T.Time, span: 1 },
  { ...Pallet.updatedTime, type: T.Time, span: 1 }
]

export const PalletInfoWrapUp = T.generateWrapUp(PalletInfoPicks)

export const PalletTableHeaders = [
  {
    ...Pallet.no,
    type: T.Link,
    width: 100,
    linkKey: Pallet.no.key,
    link: 'goToPalletDetail',
    sortable: 'custom',
    defaultSort: true,
    defaultOrder: T.Descending
  },
  {
    ...Pallet.status,
    label: 'Status',
    type: T.Tag,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        case PalletStatus.PalletUpcoming:
          return 'warning'
        case PalletStatus.PalletOffStack:
          return 'success'
        case PalletStatus.PalletDeleted:
          return 'info'
        default:
          return null
      }
    },
    sortable: 'custom'
  },
  {
    ...Container.no,
    key: 'riiContainerNo',
    width: 100,
    sortable: 'custom'
  },
  {
    ...Pallet.groupName
  },
  {
    ...Pallet.address,
    label: 'Destination',
    type: T.AddressTag,
    sortable: 'custom',
    col: 'address_id'
  },
  { ...Pallet.hold, type: T.HoldTag, width: 60, sortable: 'custom' },
  {
    ...Shipment.no,
    key: 'shipmentNo',
    label: 'Shipment',
    type: T.Text,
    sortable: 'custom',
    col: 'shipment_no'
  },
  // {
  //   ...Pallet.priority,
  //   label: 'Priority',
  //   type: T.Tag,
  //   width: 70,
  //   effect: 'plain'
  // },
  {
    type: T.Text,
    label: 'Slot No.',
    key: 'slotNo',
    col: 'slot_no',
    sortable: 'custom'
  },
  {
    ...Pallet.quantity,
    type: T.Number,
    effect: 'dark',
    width: 70,
    sortable: 'custom'
  }
]

export const PalletSearchForm = [
  {
    label: 'Pallet No. (starts with P)',
    key: 'fuzzyPalletNo',
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    prepend: T.PrependText,
    prependValue: 'P-',
    convertor: (header, value) => {
      return header.prependValue + value
    }
  },
  {
    label: 'RII Container No.',
    key: 'riiContainerNo',
    type: T.TextInput,
    example: 'C-23-0190',
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (value) return header.prependValue + appendBefore(4, '0', value)
      return undefined
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('C')[0].value,
    prependOptions: getYearsPrependOptions('C')
  },
  // {
  //   ...Pallet.deliveryAddress,
  //   type: T.TextInput,
  //   example: 'ONT8',
  //   default: '',
  //   value: '',
  //   validators: [],
  //   convertor: T.DefaultConvertor
  // },
  {
    label: 'Position',
    key: 'fuzzySlotNo',
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    label: 'SKU',
    key: 'fuzzySku',
    type: T.TextInput,
    example: '',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    label: 'Priority',
    key: 'priorityList',
    type: T.Select,
    multiple: true,
    default: [],
    value: [...Pallet.priority.options],
    options: [...Pallet.priority.options],
    validators: [T.RequiredNotEmptyListValidator]
  },
  {
    label: 'Pallet Status',
    key: 'statusList',
    type: T.Select,
    multiple: true,
    example: 'All',
    default: 'All',
    options: [...Pallet.status.options],
    value: [PalletUpcoming, PalletOnStack, PalletOffStack, PalletOnStage],
    validators: [T.RequiredNotEmptyListValidator],
    convertor: T.DefaultConvertor
  },
  {
    type: T.TimeRange,
    key: 'containerETARange',
    label: 'Container ETA',
    value: []
  },
  {
    type: T.TimeRange,
    key: 'containerEstimatedDeliveryDateRange',
    label: 'Container Estimated Delivery',
    value: []
  }
]

export const PalletSearchParamsWrapUp = searchForm => {
  const params = T.DefaultWarpSearchForm(searchForm)
  return params
}

export const PalletInfoModifyForm = Object.fromEntries(
  [
    {
      ...Pallet.priority,
      span: 1,
      type: T.Select,
      example: 'All',
      default: 'All',
      value: 'All',
      validators: [T.RequiredValidator]
    },
    {
      ...Pallet.quantity,
      span: 1,
      type: T.NumberInput,
      example: 0,
      default: 0,
      value: 0,
      validators: [T.RequiredValidator]
    },
    {
      ...Pallet.hold,
      span: 1,
      type: T.HoldSelect,
      example: false,
      default: false,
      value: false,
      mutable: true,
      validators: [T.RequiredValidator]
    },
    {
      label: 'Pallet Status',
      key: 'status',
      span: 1,
      type: T.Select,
      multiple: true,
      default: PalletOnStack,
      options: [...Pallet.status.options],
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      key: 'address',
      label: 'Deliver Address',
      type: T.AddressSelect,
      value: null,
      span: 2,
      validators: []
    }
  ].map(one => [one.key, one])
)

export const PalletModifyForm = [
  {
    ...Pallet.quantity,
    type: T.NumberInput,
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    ...Pallet.priority,
    type: T.Select,
    default: NormalPallet,
    value: '',
    validators: [T.RequiredValidator]
  },
  {
    ...Pallet.hold,
    type: T.Checkbox,
    activeText: 'Hold',
    value: '',
    validators: [T.RequiredValidator]
  }
]
export const StockDefaultSort = [
  {
    ...Order.riiOrderNo,
    defaultSort: true,
    defaultOrder: T.Descending
  }
]
export const StockUnHoldTableHeaders = [
  {
    key: 'inCartCount',
    label: '✓',
    slotName: 'inCartCount',
    type: T.SlotType,
    width: 50
  },
  {
    ...Order.riiOrderNo,
    type: T.Link,
    width: 100,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    type: T.Link,
    label: 'RII Con#',
    key: 'riiContainerNo',
    width: 80,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    col: 'rii_container_no',
    sortable: 'custom'
  },
  {
    type: T.Link,
    label: 'Con#',
    key: 'containerNo',
    width: 100,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    col: 'container_no',
    sortable: 'custom'
  },
  {
    type: T.Text,
    label: 'Group',
    key: 'groupName',
    width: 100
  },
  {
    type: T.AddressTag,
    label: 'Address',
    key: 'address',
    col: 'address_id',
    sortable: 'custom'
  },
  {
    type: T.SlotType,
    slotName: 'totalPalletCount',
    label: 'Pallets CNT',
    width: 50,
    key: 'palletIds.length'
  },
  {
    type: T.Time,
    label: 'EST Received Date',
    key: 'containerEstimatedDeliveryDate',
    width: 100,
    sortable: 'custom',
    col: 'container_estimated_delivery_date'
  },
  {
    type: T.Time,
    label: 'Act Received Date',
    key: 'containerDeliveryDate',
    width: 100,
    sortable: 'custom'
  }
]

export const StockHoldTableHeaders = [
  {
    ...Order.riiOrderNo,
    type: T.Link,
    width: 100,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    type: T.Link,
    label: 'RII Container#',
    key: 'riiContainerNo',
    width: 80,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    col: 'rii_container_no',
    sortable: 'custom'
  },
  {
    type: T.Link,
    label: 'Con#',
    key: 'containerNo',
    width: 80,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    col: 'container_no',
    sortable: 'custom'
  },
  {
    type: T.Text,
    label: 'Group',
    key: 'groupName',
    width: 100,
    col: 'group_name',
    sortable: 'custom'
  },
  {
    type: T.AddressTag,
    label: 'Address',
    key: 'address',
    col: 'address_id',
    sortable: 'custom'
  },
  {
    type: T.SlotType,
    slotName: 'totalPalletCount',
    label: 'Pallets CNT',
    width: 60,
    key: 'palletIds.length'
  },
  {
    type: T.Time,
    label: 'EST Received Date',
    key: 'containerEstimatedDeliveryDate',
    width: 100,
    sortable: 'custom'
  },
  {
    type: T.Time,
    label: 'Act Received Date',
    key: 'containerDeliveryDate',
    width: 100,
    sortable: 'custom'
  }
]

export const StockShippedTableHeaders = [
  {
    ...Order.riiOrderNo,
    type: T.Link,
    width: 100,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    type: T.Link,
    label: 'Ship No',
    key: 'shipmentNo',
    width: 80,
    linkKey: 'shipmentNo',
    link: 'goToShipmentDetail',
    col: 'shipment_no',
    sortable: 'custom'
  },
  {
    type: T.Link,
    label: 'RII Container#',
    key: 'riiContainerNo',
    width: 80,
    linkKey: 'orderNo',
    link: 'goToOrderDetail',
    col: 'rii_container_no',
    sortable: 'custom'
  },
  {
    type: T.AddressTag,
    label: 'Address',
    key: 'address',
    col: 'address_id',
    sortable: 'custom'
  },
  {
    type: T.Text,
    label: 'Group',
    key: 'groupName'
  },
  {
    type: T.SlotType,
    slotName: 'totalPalletCount',
    label: 'Pallets CNT',
    width: 60,
    key: 'palletIds.length'
  },
  {
    label: 'Container No.',
    key: 'containerNo',
    col: 'container_no',
    width: 120,
    type: T.Text
  },
  {
    type: T.Link,
    label: 'Job#',
    key: 'unloadingJobNo',
    width: 80,
    linkKey: 'unloadingJobNo',
    link: 'goToJobDetail',
    col: 'unloading_job_no',
    sortable: 'custom'
  },
  {
    type: T.Time,
    label: 'Shipped Date',
    key: 'shippedDate',
    width: 120,
    sortable: 'custom'
  }
]

export const StockAddressTableHeaders = [
  {
    key: 'inCartCount',
    label: '✓',
    slotName: 'inCartCount',
    type: T.SlotType,
    width: 50
  },
  {
    type: T.AddressTag,
    label: 'Address',
    key: 'address'
  },
  {
    type: T.Text,
    label: 'Order CNT',
    key: 'orders.length',
    width: 100
  },
  {
    type: T.SlotType,
    slotName: 'totalPalletCount',
    label: 'Pallets CNT',
    width: 60,
    key: 'palletIds.length'
  }
]

export const StockSearchForm = [
  {
    label: 'RII Order NO.(after OTRII)',
    key: 'fuzzyRiiOrderNo',
    type: T.TextInput,
    example: 'OTRII2022110101',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + value
    },
    prepend: T.PrependText,
    prependValue: 'OTRII'
  },
  {
    label: 'RII Container No.',
    key: 'fuzzyRiiContainerNo',
    type: T.TextInput,
    example: 'C-23-0190',
    inputAccept: 'number',
    default: '',
    value: '',
    validators: [],
    convertor: (header, value) => {
      if (!value) return ''
      return header.prependValue + appendBefore(4, '0', value)
    },
    prepend: T.PrependSelect,
    prependValue: getYearsPrependOptions('C')[0].value,
    prependOptions: getYearsPrependOptions('C')
  },
  {
    label: 'Container No.',
    key: 'fuzzyContainerNo',
    type: T.TextInput,
    example: 'RII-1234567',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    ...Pallet.deliveryAddress,
    label: 'Ship Address',
    key: 'fuzzyAddress',
    type: T.TextInput,
    example: 'ONT8',
    default: '',
    value: '',
    validators: [],
    convertor: T.DefaultConvertor
  },
  {
    label: 'Pallet Priority',
    key: 'priorityList',
    type: T.Select,
    example: 'All',
    default: 'All',
    span: 2,
    multiple: true,
    value: [...Pallet.priority.options],
    options: [...Pallet.priority.options],
    validators: [T.RequiredNotEmptyListValidator],
    convertor: T.DefaultConvertor
  },
  {
    label: 'Include Upcoming',
    key: 'includeUpcomingPallet',
    type: T.Select,
    example: 'true',
    default: 'true',
    value: 'true',
    multiple: false,
    options: ['true', 'false'],
    validators: [],
    convertor: T.DefaultBooleanConvertor
  },
  {
    label: 'Customer',
    key: 'customerName',
    type: T.RemoteSelect,
    default: '',
    value: '',
    loading: false,
    options: [],
    validators: [],
    convertor: T.DefaultConvertor,
    method: function (nameLike) {
      const that = this
      that.loading = true
      queryCustomers({ nameLike }).then(res => {
        that.loading = false
        that.options.splice(0, that.options.length)
        that.options.push(...res.map(one => ({ key: one.name, label: one.name, value: one.name })))
      })
    }
  }
]

export const StockSearchFormWrapUp = searchForm => {
  return T.DefaultWarpSearchForm(searchForm)
}

export const StockPalletTableHeaders = [
  {
    ...Pallet.no,
    type: T.Link,
    width: 120,
    linkKey: Pallet.no.key,
    link: 'goToPalletDetail'
  },
  {
    ...Pallet.groupName,
    width: 120
  },
  // {
  //   ...Pallet.deliveryAddress,
  //   width: 110,
  //   label: 'Destination'
  // },
  {
    type: T.HoldTag,
    width: 100,
    label: 'Hold',
    key: 'hold',
    col: 'hold'
  },
  {
    ...Pallet.status,
    label: 'status',
    type: T.Tag,
    width: 80,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        case PalletStatus.PalletUpcoming:
          return 'warning'
        case PalletStatus.PalletOffStack:
          return 'success'
        case PalletStatus.PalletDeleted:
          return 'info'
        default:
          return null
      }
    }
  }
]

export const PalletsReleaseForm = Object.fromEntries(
  [
    {
      ...Pallet.hold,
      span: 1,
      type: T.HoldSelect,
      example: 'False',
      default: 'False',
      value: 'False',
      mutable: true,
      validators: [T.RequiredValidator]
    },
    {
      key: 'address',
      label: 'Deliver Address',
      type: T.AddressSelect,
      value: null,
      span: 2,
      validators: []
    }
  ].map(one => [one.key, one])
)

export const OrderCompletePalletTableHeaders = [
  {
    ...Pallet.no,
    type: T.Link,
    width: 100,
    linkKey: Pallet.no.key,
    link: 'goToPalletDetail',
    sortable: 'custom',
    defaultSort: true
  },
  {
    ...Pallet.status,
    label: 'Status',
    type: T.Tag,
    effect: 'plain',
    tagType: e => {
      switch (e) {
        case PalletStatus.PalletUpcoming:
          return 'warning'
        case PalletStatus.PalletOffStack:
          return 'success'
        case PalletStatus.PalletDeleted:
          return 'info'
        default:
          return null
      }
    },
    sortable: 'custom'
  },
  {
    ...Shipment.no,
    key: 'shipmentNo',
    label: 'Shipment',
    type: T.Text,
    sortable: 'custom',
    col: 'shipment_no'
  },
  {
    ...Pallet.address,
    label: 'Destination',
    type: T.AddressTag,
    sortable: 'custom',
    col: 'address_id'
  },
  { ...Pallet.hold, type: T.HoldTag, width: 60, sortable: 'custom' },
  {
    type: T.Text,
    label: 'Slot No.',
    key: 'slotNo',
    col: 'slot_no',
    sortable: 'custom'
  }
]

export const PalletScanProductsHeaders = [
  {
    type: T.String,
    label: 'Product SKU',
    key: 'productNo',
    width: 100
  },
  {
    type: T.String,
    label: 'Product Name',
    key: 'productName',
    width: 100
  },
  {
    type: T.String,
    label: 'Serial No.',
    key: 'serialNo',
    width: 200
  },
  {
    type: T.String,
    label: 'Quantity',
    key: 'cartonQuantity',
    width: 100
  },
  {
    type: T.String,
    label: 'SSCC',
    key: 'sscc',
    width: 200
  },
  {
    type: T.Time,
    key: 'createdTime',
    label: 'Created Time',
    width: 100,
    sortable: 'custom'
  }
]
